/* Canvello v8 — card quick add (Task 3.1). snippets/cv-card.liquid.
 *
 * The card's quick add is a plain POST to /cart/add (works without JS: the
 * visitor lands on the cart). With JS it posts /cart/add.js in place, shows
 * "Added" on the button for a moment and fires cart:updated with the new
 * item count, which the header's bag listens for. On a refusal (sold out,
 * stock limit) the button says so and the message is announced.
 *
 * Delegated from document, so cards added later (filtered grids, 4.1) work.
 */
(() => {
  if (window.CVCard) return;

  let live = null;
  const say = (text) => {
    if (!live) {
      live = document.createElement('p');
      live.className = 'visually-hidden';
      live.setAttribute('role', 'status');
      document.body.appendChild(live);
    }
    live.textContent = '';
    requestAnimationFrame(() => (live.textContent = text));
  };

  const json = (r) => r.json().then((body) => ({ ok: r.ok, body }));

  document.addEventListener('submit', (e) => {
    const form = e.target.closest && e.target.closest('form[data-cv-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    const btn = form.querySelector('button');
    const label = form.querySelector('[data-cv-add-label]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    const text = label ? label.textContent : '';
    const s = window.CVCardStrings || {};
    btn.setAttribute('aria-busy', 'true');

    const settle = (msg, ms) => {
      if (label) label.textContent = msg;
      setTimeout(() => {
        if (label) label.textContent = text;
        btn.removeAttribute('aria-busy');
      }, ms);
    };

    fetch(form.action.replace(/\/?$/, '.js'), {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form),
    })
      .then(json)
      .then(({ ok, body }) => {
        if (!ok) throw new Error(body.description || body.message || s.error);
        return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
          headers: { Accept: 'application/json' },
        }).then((r) => r.json());
      })
      .then((cart) => {
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart, item_count: cart.item_count } }));
        settle(s.added || 'Added', 2200);
      })
      .catch((err) => {
        const msg = (err && err.message) || s.error || '';
        settle(s.error_short || msg, 3200);
        if (msg) say(msg);
      });
  });

  window.CVCard = true;
})();
